import { render, staticRenderFns } from "./RecentNews.vue?vue&type=template&id=a7544cfa&scoped=true&"
import script from "./RecentNews.vue?vue&type=script&lang=js&"
export * from "./RecentNews.vue?vue&type=script&lang=js&"
import style1 from "./RecentNews.vue?vue&type=style&index=1&id=a7544cfa&scoped=true&lang=css&"
import style2 from "./RecentNews.vue?vue&type=style&index=2&id=a7544cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7544cfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VRow})
